/*
 * In this file we combine all our reducers to one single reducer which we can use in our app entry
 * */
import { combineReducers } from 'redux';
import rootReducer from './../root/state/root-reducer';
import searchBoxReducer from './../search-box/state/search-box-reducer';
import initialStateReducer from './../initial-app-state/state/initial-app-state-reducer';

const reducers = combineReducers({
  rootReducer,
  searchBoxReducer,
  initialStateReducer
});

export default reducers;



/** WEBPACK FOOTER **
 ** app/components/common/reducers.js
 **/